import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import $ from "jquery";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(async () => {
  // Функция для загрузки скрипта
  // const loadScript = (src: string): Promise<void> => {
  //   return new Promise((resolve, reject) => {
  //     const script = document.createElement("script");
  //     script.src = src;
  //     script.async = true;
  //     script.onload = () => {
  //       console.log(`${src} загружен`);
  //       resolve();
  //     };
  //     script.onerror = () => reject(new Error(`Не удалось загрузить ${src}`));
  //     document.body.appendChild(script);
  //   });
  // };
  // try {
  //   // 1. Загружаем jQuery
  //   await loadScript("https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js");
  //   if (!window.jQuery) throw new Error("jQuery не инициализирован");
  //   // 2. Загружаем webflow.js
  //   await loadScript("/webflow.js"); // Убедитесь, что путь правильный
  //   if (!window.Webflow) throw new Error("Webflow не инициализирован");
  //   // 3. Инициализируем Webflow
  //   window.Webflow.ready();
  //   const ix2 = window.Webflow.require("ix2");
  //   if (ix2) {
  //     ix2.init();
  //     console.log("Webflow IX2 инициализирован");
  //   } else {
  //     console.warn("IX2 не найден");
  //   }
  // } catch (error) {
  //   console.error("Ошибка загрузки скриптов:", error);
  // }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})